import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import actions from 'actions';

const {
  loadCountiesSaga
} = actions;

class CountyInput extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    loadCounties: PropTypes.func,
    value: PropTypes.string,
    onChange: PropTypes.func,
    errors: PropTypes.array,
    counties: PropTypes.array,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    selectProps: PropTypes.object
  };

  static defaultProps = {
    label: ''
  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.loadCounties();
  }

  render() {
    const {
      value,
      onChange,
      errors,
      counties,
      label,
      placeholder = 'County',
      selectProps = {}
    } = this.props;
    return (
      <div className="col s12">
        <p className="input_country">{label}</p>
        <Select
          options={this.props.counties}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...selectProps}
        />
        <div style={{ color: 'red', fontSize: '0.875rem' }}>
          {(errors || []).join('. ')}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    counties: state.suggestions.county.values
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadCounties: () => dispatch(loadCountiesSaga())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CountyInput);



/** WEBPACK FOOTER **
 ** ./src/containers/Input/CountyInput.jsx
 **/